import React, { useEffect, useRef, useState } from 'react';
import { TouchableOpacity } from 'react-native';
import { useToast } from 'react-native-toast-notifications';
import jwt_decode from 'jwt-decode';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { BLink, BText, showToast } from '../../components';
import { Input, Button, FormContainer, ButtonContainer, InputRefProps, TextContainer } from '../../components/Form';
import { userLogin } from '../../store/user/userActions';
import { setLoading } from '../../store/portal/portalActions';
import { theme } from '../../styles';
import { themeConfig } from '../../styles/themeConfig';
import { GoogleSignUp, FacebookSignUp } from '../Auth';
// import { FacebookSignUp } from '../Auth/FacebookSignUp';

type props = {
  navigation?: any;
  inPage?: boolean;
  onClose?: Function;
};

export const LoginForm = ({ navigation, inPage = false, onClose = () => null }: props) => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const rtUser = useAppSelector(s => s.user);

  const inputMobileNumber = useRef<InputRefProps>(null);
  const inputPassword = useRef<InputRefProps>(null);

  const [showSignUpOptions, setShowSignUpOptions] = useState<boolean>(false);

  // const clientId = "157120409370-foqrvuqripo455rniivfbfphd45sgfto.apps.googleusercontent.com";
  // const apiKey = "AIzaSyBQzY8lbxgZiTwVyAeLMti0Eeb28_IvmIo";

  useEffect(() => {
    dispatch(setLoading(false, 'LoginForm'));
    if (rtUser.loginStatus === true) {
      // dispatch(setLoading(false, 'LoginForm'));
      setTimeout(() => {
        if (inPage) {
          navigation.navigate('home');
        } else if (onClose) {
          onClose();
        }
      }, 1000);
    } else if (rtUser.loginStatus === false && rtUser.errorMsg) {
      showToast(toast, { message: rtUser.errorMsg, type: 'error' });
    }
  }, [rtUser.loginStatus]);

  useEffect(() => {
    // gapi
  }, []);

  const doLoginBtn = async () => {
    dispatch(setLoading(true, 'LoginForm'));

    const mobileNo = inputMobileNumber.current?.value;
    const password = inputPassword.current?.value;

    if (mobileNo && password) {
      dispatch(
        userLogin({
          mobileNo: mobileNo,
          password: password,
        }),
      );
    } else {
      dispatch(setLoading(false, 'LoginForm'));
      showToast(toast, { message: 'Please key in mobile number and password', type: 'error' });
    }
  };

  const canClose = () => {
    if (onClose) onClose();
  };

  const showSignUp = () => {
    setShowSignUpOptions(prevState => !prevState);
  };

  const mobileNoRegister = () => {
    let name = '';
    let email = '';
    let otherLogin = false;

    navigation.navigate('register', { name, email, otherLogin });
  };

  const handleGoogleSuccess = (res: any) => {
    console.log('Google login success:', res.credential);

    const decoded: { name?: string; email?: string } = jwt_decode(res.credential);
    console.log('Google login decoded:', decoded);

    let name = decoded.name;
    let email = decoded.email;
    let otherLogin = true;

    navigation.navigate('register', { name, email, otherLogin });

    // Handle successful login here
  };

  const handleGoogleError = () => {
    console.log('Google login error:');
    // Handle login error here
  };

  const handleFacebookResponse = (res: any) => {
    console.log('facebook login:', res);

    let name = res.name;
    let email = res.email;
    let otherLogin = true;

    navigation.navigate('register', { name, email, otherLogin });
  };

  return (
    <FormContainer title={inPage ? '' : 'Login'} style={{ zIndex: 99 }}>
      <Input id="Mobile Number" label="Mobile Number" ref={inputMobileNumber} />
      <Input type={'password'} id="password" label="Password" ref={inputPassword} />
      <ButtonContainer direction={inPage ? 'vertical' : 'horizontal'}>
        <Button onPress={() => doLoginBtn()}>Login</Button>
        {!inPage && (
          <Button onPress={() => onClose()} colorName="grey">
            Cancel
          </Button>
        )}
      </ButtonContainer>
      <TextContainer align="center">
        <BLink to={{ screen: 'forgot-password' }} onPress={canClose}>
          Forget Password
        </BLink>
      </TextContainer>

      <TextContainer align="center">
        <BText>Doesn't have an account? </BText>
        <BText style={{ color: theme.colors.link }} onPress={showSignUp}>
          Sign Up
        </BText>
      </TextContainer>

      {showSignUpOptions && (
        <ButtonContainer direction={inPage ? 'vertical' : 'horizontal'}>
          <TouchableOpacity
            style={{
              position: 'relative',
              justifyContent: 'center',
              width: '100%',
              borderRadius: themeConfig.settings.borderRadius,
              backgroundColor: themeConfig.colors.black,
              marginTop: 8,
              marginBottom: 8,
            }}
            onPress={mobileNoRegister}
          >
            <BText
              style={{
                color: 'white',
                fontSize: themeConfig.settings.fontSize.button,
                fontWeight: 'bold',
                lineHeight: 30,
                textAlign: 'center',
              }}
            >
              Mobile number
            </BText>
          </TouchableOpacity>
          <GoogleSignUp onSuccess={handleGoogleSuccess} onError={handleGoogleError} />
          <FacebookSignUp onResponse={handleFacebookResponse} />
        </ButtonContainer>
      )}
    </FormContainer>
  );
};
